import { MenuProps as SelectMenuProps, createTheme } from '@mui/material'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      whiteSpace: 'inherit'
    }
  }
} as SelectMenuProps

export const createCustomizedTheme = (isDark: boolean) => {
  return createTheme({
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark
              ? 'var(--dark-chart-bg) !important'
              : 'var(--light-bg)'
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: isDark
                ? 'var(--actived-dark) !important'
                : 'rgba(25, 118, 210, 0.08)'
            },
            '&.MuiMenuItem-root': {
              fontSize: 'var(--fs-md) !important'
            }
          }
        }
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            width: '100%',
            padding: '0.5rem 1rem'
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            width: '100%'
          }
        }
      }
    }
  })
}

export { CustomizedSelect } from './CustomizedSelect'
export { SelectForm } from './SelectForm'
export { SelectHorizontalForm } from './SelectHorizontalForm'
export { SelectMultipleForm } from './SelectMultipleForm'
export { SelectMultipleCustom } from './SelectMultipleCustom'
